import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { RecordMapWorkspace } from "@/features/map";
import {
	type MapViewSearch,
	mapViewSearchSchema,
} from "@/features/map/lib/map-view-search";
import { recordInstanceQueryOptions } from "@/services/record";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/records/$recordId/workspace/map",
)({
	component: RecordWorkspaceMapTab,
	validateSearch: (search): MapViewSearch => mapViewSearchSchema.parse(search),
});

function RecordWorkspaceMapTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/records/$recordId/workspace/map",
	});
	const recordById = useQuery(
		recordInstanceQueryOptions.detail(params.recordId, {
			organizationId: params.orgId,
		}),
	);

	return (
		<RecordMapWorkspace
			orgId={params.orgId}
			recordId={params.recordId}
			record={recordById.data}
			isRecordPending={recordById.isPending}
			hostJobId={params.ticketId}
		/>
	);
}
